import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon, LockIcon } from 'lucide-react';
export function TrustSection() {
  const benefits = ['Non-habit forming natural formula', 'Melatonin free for natural sleep cycle', 'Clinically tested ingredients', 'Improved professional performance'];
  return <div className="bg-white rounded-lg shadow-lg p-6 text-center" data-id="element-477">
      <div className="mb-6" data-id="element-478">
        <h2 className="text-xl font-semibold mb-2" data-id="element-479">Our Risk-Free Guarantee</h2>
        <p className="text-gray-600" data-id="element-480">
          Try NightPhase for 30 nights. If you're not completely satisfied,
          we'll refund your purchase - no questions asked.
        </p>
      </div>
      <div className="mb-6" data-id="element-481">
        <h3 className="font-medium mb-3" data-id="element-482">Secure Payment Methods</h3>
        <div className="flex justify-center space-x-4" data-id="element-483">
          <img src="https://cdn.pixabay.com/photo/2015/05/26/09/37/paypal-784404_1280.png" alt="PayPal" className="h-8 object-contain" data-id="element-484" />
          <img src="https://cdn.pixabay.com/photo/2013/10/01/10/29/credit-card-189069_1280.png" alt="Credit Card" className="h-8 object-contain" data-id="element-485" />
          <img src="https://cdn.pixabay.com/photo/2015/08/26/14/02/secure-payment-908886_1280.png" alt="Secure Payment" className="h-8 object-contain" data-id="element-486" />
        </div>
      </div>
      <div className="mb-6" data-id="element-487">
        <div className="flex justify-center items-center space-x-2" data-id="element-488">
          <ShieldCheckIcon className="h-5 w-5 text-green-600" data-id="element-489" />
          <span className="text-green-600 font-medium" data-id="element-490">
            Your data is secure and encrypted
          </span>
        </div>
      </div>
      <div className="border-t pt-6" data-id="element-491">
        <h3 className="font-medium mb-4" data-id="element-492">Why Choose NightPhase?</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left max-w-xl mx-auto" data-id="element-493">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start" data-id="element-494">
              <CheckCircleIcon className="h-5 w-5 text-indigo-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-495" />
              <span data-id="element-496">{benefit}</span>
            </li>)}
        </ul>
      </div>
      <div className="mt-6 text-sm text-gray-500" data-id="element-497">
        <p data-id="element-498">
          <a href="#" className="text-indigo-600 hover:text-indigo-800 underline" data-id="element-499">
            Privacy Policy
          </a>{' '}
          |
          <a href="#" className="text-indigo-600 hover:text-indigo-800 underline ml-2" data-id="element-500">
            Terms of Service
          </a>
        </p>
      </div>
    </div>;
}